<template>
  <div class="ba-flex ba-text-white">
    <button
      type="button"
      class="ba-w-8 ba-mr-1 ba-px-2"
      @click="$emit('click')"
    >
      <vis-icon-editing class="ba-w-full ba-h-full" />
    </button>
    <button
      type="button"
      class="ba-w-8 ba-px-2"
      @click="$emit('click')"
    >
      <vis-icon-drag class="ba-w-full ba-h-full" />
    </button>
  </div>
</template>

<script>
export default {
  name: "vis-approval-queue-stage-edit-controls"
}
</script>
